import React, { useEffect } from 'react';
import { PIXEL_ID, initPixel, loadPixelScript } from '../utils/metaPixel';
const SCRIPT_DELAY = 2000;

/**
 * Meta Pixel. PageView is queued on page load; fbevents.js downloads after
 * window.load + 2s so it never blocks the initial render.
 */
export function MetaPixel() {
  useEffect(() => {
    initPixel();
    let delayTimer: number | undefined;
    function scheduleLoad() {
      delayTimer = window.setTimeout(loadPixelScript, SCRIPT_DELAY);
    }
    if (document.readyState === 'complete') {
      scheduleLoad();
    } else {
      window.addEventListener('load', scheduleLoad, {
        once: true
      });
    }
    return () => {
      if (delayTimer) window.clearTimeout(delayTimer);
      window.removeEventListener('load', scheduleLoad);
    };
  }, []);
  return <noscript data-id="element-178" data-mp="mlnqkgpq18kc">
      <img height="1" width="1" alt="" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-179" data-mp="mkupnwdg1da4" />
    </noscript>;
}